import type { PropsWithChildren } from "react";

export const CardsGrid = ({ children }: PropsWithChildren) => (
  <div className="grow">
    <div className="grid grow grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
      {children}
    </div>
  </div>
);
